import React from "react";
import PropTypes from "prop-types";

PlateForkSpoonSvg.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default function PlateForkSpoonSvg({ className, style }) {
  return (
    <svg
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22.75"
      height="23.25"
      viewBox="0 0 35.75 23.25"
    >
      <g transform="translate(0.375 0.375)">
        <path
          className="a"
          d="M7.984,11.742C6,11.742,4.46,14.578,4.46,17.018a3.293,3.293,0,0,0,3.042,3.6V24.9a1.444,1.444,0,0,0-.98,1.359V32.8a1.462,1.462,0,0,0,2.924,0V26.259A1.446,1.446,0,0,0,8.466,24.9V20.622a3.293,3.293,0,0,0,3.042-3.6C11.509,14.578,9.969,11.742,7.984,11.742Zm.5,21.053a.5.5,0,0,1-1,0V26.259a.5.5,0,0,1,1,0Zm-.5-13.088a2.391,2.391,0,0,1-2.56-2.689c0-2.14,1.292-4.322,2.56-4.322s2.56,2.181,2.56,4.322A2.39,2.39,0,0,1,7.984,19.707Z"
          transform="translate(-4.46 -11.742)"
        />
        <path
          className="a"
          d="M23.416,13.07a9.855,9.855,0,1,0,9.866,9.854A9.871,9.871,0,0,0,23.416,13.07Zm0,18.757a8.9,8.9,0,1,1,8.912-8.9A8.918,8.918,0,0,1,23.416,31.827Z"
          transform="translate(-5.761 -11.932)"
        />
        <path
          className="a"
          d="M24.084,17.041a6.453,6.453,0,1,0,6.563,6.451A6.516,6.516,0,0,0,24.084,17.041Zm0,11.957a5.505,5.505,0,1,1,5.6-5.505A5.559,5.559,0,0,1,24.084,29Z"
          transform="translate(-6.43 -12.5)"
        />
        <path
          className="a"
          d="M43.983,13.07a.48.48,0,0,0-.482.477v5a1.369,1.369,0,0,1-1.374,1.36h-.394V13.547a.482.482,0,0,0-.965,0V19.9h-.394A1.369,1.369,0,0,1,39,18.545v-5a.482.482,0,0,0-.965,0v5a2.329,2.329,0,0,0,2.338,2.314h.394v4.235a1.443,1.443,0,0,0-.98,1.359v6.533a1.462,1.462,0,0,0,2.924,0V26.453a1.444,1.444,0,0,0-.979-1.359V20.859h.394a2.329,2.329,0,0,0,2.338-2.314v-5A.476.476,0,0,0,43.983,13.07ZM41.748,32.986a.5.5,0,0,1-1,0V26.453a.5.5,0,0,1,1,0Z"
          transform="translate(-9.463 -11.932)"
        />
      </g>
    </svg>
  );
}
